module.exports = __webpack_public_path__ + "static/media/otmannouinou.bc8e1b4c.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/otmannouinou.webp
// module id = 349
// module chunks = 0